module.exports = __webpack_public_path__ + "media/startrakety.fe8e7609.mp3";